import React from "react";

function NotificationsPage() {
  return (
    <div className="main-content">
      <h1>Notifications Placeholder</h1>
    </div>
  );
}
export default NotificationsPage;